var _jsxFileName = "/src/main/react/src/main/app/components/navigation/Error.js";
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { Typography, Grid } from '@material-ui/core';
import queryString from "query-string";
import Util from "../../util/Util";
import { Q_STRING } from "../domain/constants";
import { HOMEPAGE } from "../Routes";
import { retrieveFromQueryString } from "../../util/QueryStringUtil";
const styles = () => ({});
class Error extends Component {
  constructor(props) {
    super(props);
    const querystringValues = queryString.parse(this.props.location.search);
    const searchMessage = retrieveFromQueryString(Q_STRING.MESSAGE, querystringValues);
    this.state = {
      message: searchMessage != null ? searchMessage : props.message != null ? props.message : 'Something went wrong. Please contact a TPIC administrator'
    };
  }
  render() {
    const message = this.state.message;
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      alignItems: 'center',
      alignContent: 'center',
      justify: 'center',
      direction: 'column',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 21
      }
    }, message)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Link, {
      to: HOMEPAGE,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'h5',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 25
      }
    }, "Return home"))));
  }
}
export default withStyles(styles)(withRouter(Error));